const IconTicket = ({ className }) => {
    return (
        <svg
            width='31'
            height='31'
            viewBox='0 0 31 31'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                id='Vector'
                d='M9.7164 20.6977L4.78296 25.7634M21.2836 20.6977L26.217 25.7634M4.7059 6.29169L9.7144 11.2832M26.2941 6.29169L21.2856 11.2832M30 15.5C30 23.5081 23.5081 30 15.5 30C7.49187 30 1 23.5081 1 15.5C1 7.49187 7.49187 1 15.5 1C23.5081 1 30 7.49187 30 15.5ZM23 15.5C23 19.6421 19.6421 23 15.5 23C11.3579 23 8 19.6421 8 15.5C8 11.3579 11.3579 8 15.5 8C19.6421 8 23 11.3579 23 15.5Z'
                strokeWidth='2'
            />
        </svg>
    );
};

export default IconTicket;
